import _cloneDeep from 'lodash/cloneDeep';

export default {
  event: (state) => _cloneDeep(state.event),
  events: (state) => _cloneDeep(state.events),
  eventTask: (state) => _cloneDeep(state.eventTask),
  eventTasks: (state) => _cloneDeep(state.eventTasks),
};
